import type { SDSTableAlign } from '../types/table.types';

interface SDSTableColumnMeta {
  dataTestId?: string;
  cellDataTestId?: string;
  align?: SDSTableAlign;
  width?: string;
}

/** A column's alignment, applied to its header and its cells alike. */
export function getColumnAlign(meta: unknown): SDSTableAlign | undefined {
  const columnMeta = meta as SDSTableColumnMeta | undefined;
  return columnMeta?.align;
}

/**
 * A column's fixed width.
 *
 * Applied to the header and the cells alike. In the plain table the two share
 * one `<table>` and the header alone would do, but the virtualized table
 * renders every row as its own `<table>` — nothing propagates from the header
 * there, and each row would size itself from its own content.
 */
export function getColumnWidth(meta: unknown): string | undefined {
  const columnMeta = meta as SDSTableColumnMeta | undefined;
  return columnMeta?.width;
}

export function getHeaderDataTestId(columnId: string, meta: unknown): string | undefined {
  if (columnId === '_selection') {
    return undefined;
  }

  const columnMeta = meta as SDSTableColumnMeta | undefined;
  return columnMeta?.dataTestId;
}

export function getCellDataTestId(columnId: string, meta: unknown): string | undefined {
  if (columnId === '_selection' || columnId === '_actions') {
    return undefined;
  }

  const columnMeta = meta as SDSTableColumnMeta | undefined;
  return columnMeta?.cellDataTestId;
}
